import { component } from 'picoapp'

export default component(node => {
    const
        linklistToggles = node.querySelectorAll('[data-mobile-linklist-toggle]'),
        childLinklists = node.querySelectorAll('[data-mobile-child-linklist]'),
        childLinklistToggles = node.querySelectorAll('[data-mobile-child-linklist-toggle]'),
        grandchildLinklists = node.querySelectorAll('[data-mobile-grandchild-linklist]'),
        linkIcons = node.querySelectorAll('[data-link-icon]'),
        childLinkIcons = node.querySelectorAll('[data-childlink-icon]')


    //*/ Toggle child linklists /*//
    linklistToggles.forEach((toggle, i) => {
        toggle.addEventListener('click', (e) => {
            if (toggle.classList.contains('has-children')) {
                e.preventDefault()

                if (childLinklists[i].style.height) {
                    childLinklists[i].style.height = null
                    childLinklists[i].classList.remove('open')
                    linkIcons[i].classList.remove('open')

                    grandchildLinklists.forEach(grandchildList => {
                        grandchildList.style.maxHeight = null
                    })

                    childLinkIcons.forEach(icon => {
                        icon.classList.remove('open')
                    })
                } else {
                    childLinklists.forEach(childList => {
                        childList.style.height = null
                        childList.classList.remove('open')
                    })

                    linkIcons.forEach(icon => {
                        icon.classList.remove('open')
                    })

                    childLinklists[i].style.height = `${childLinklists[i].scrollHeight}px`
                    childLinklists[i].classList.add('open')
                    linkIcons[i].classList.add('open')
                }
            }
        })
    })


    //*/ Toggle grandhild linklists /*//
    const childListToggleWithChildren = Array.from(childLinklistToggles).filter(childLinklist => childLinklist.classList.contains('has-children'))

    childListToggleWithChildren.forEach((childToggle, i) => {
        childToggle.addEventListener('click', (e) => {
            childLinklists.forEach(childList => {
                childList.style.height = 'unset'
            })

            if (childToggle.classList.contains('has-children')) {
                e.preventDefault()

                if (grandchildLinklists[i].style.maxHeight) {
                    grandchildLinklists[i].style.maxHeight = null
                    grandchildLinklists[i].classList.remove('open')
                    childLinkIcons[i].classList.remove('open')
                } else {
                    grandchildLinklists.forEach(grandchildList => {
                        grandchildList.style.maxHeight = null
                        grandchildList.classList.remove('open')
                    })

                    childLinkIcons.forEach(icon => {
                        icon.classList.remove('open')
                    })

                    grandchildLinklists[i].style.maxHeight = `${grandchildLinklists[i].scrollHeight}px`
                    grandchildLinklists[i].classList.add('open')
                    childLinkIcons[i].classList.add('open')
                }
            }
        })
    })
})
